import http from "@/common/http-common"
import { BASE_EXPORT_PAYMENTS } from "@/common/constant";

class PaymentProcessService {
  export(params) {
    return http.get(BASE_EXPORT_PAYMENTS.concat(localStorage.getItem('bearer_token')),{
      params: params,
      responseType: 'blob',
    });
  }

  exportLogbook(params) {
    return http.get(BASE_EXPORT_PAYMENTS.concat('logbook/').concat(localStorage.getItem('bearer_token')),{
      params: params,
      responseType: 'blob',
    });
  }

  exportSummaryReport(filterRequest, detailed = false) {
    return http.post(
      BASE_EXPORT_PAYMENTS.concat('logbook/search/').concat(localStorage.getItem('bearer_token')),
      filterRequest,
      {
        params: { detailed },
        responseType: 'blob',
      }
    );
  }

}
export default new PaymentProcessService();
